import { render, staticRenderFns } from "./ResearchInformation.vue?vue&type=template&id=b215a5a2&scoped=true"
import script from "./ResearchInformation.vue?vue&type=script&lang=js"
export * from "./ResearchInformation.vue?vue&type=script&lang=js"
import style0 from "./ResearchInformation.vue?vue&type=style&index=0&id=b215a5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b215a5a2",
  null
  
)

export default component.exports